import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useEthnicGroups = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["ethnicGroups", tenantVal],
    queryFn: async () => {
      if (!tenantVal) return [];

      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patient/ethnic-groups`
      );

      if (response && response.data) {
        return response.data;
      }
      return [];
    },
    enabled: !!tenantVal,
  });
};

